import React, {useCallback} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Logo from '../../../../assets/images/logos/logo_white_horz_full.png';
import background_image from '../../../../assets/images/onboarding/skip_tour_modal_background.png';

interface AppTourWelcomeModalProps {
  open: boolean;
  handleGoBack: () => void;
  handleSkip: () => void;
}

const AppTourWelcomeModal: React.FC<AppTourWelcomeModalProps> = ({open, handleGoBack, handleSkip}) => {
  const handleClose = useCallback(
    (_event: object, reason: string) => {
      if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
        handleSkip();
      }
    },
    [handleSkip]
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="welcome-title"
      aria-describedby="welcome-description"
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: {xs: 1, sm: 2, md: 3},
          boxShadow: {xs: 2, sm: 4, md: 8},
          width: {xs: '70vw', sm: 450, md: 520},
          height: {xs: '50vh', sm: 450, md: 550},
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${background_image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }
      }}
    >
      <DialogContent
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <Box mb={'20px'} mt={'20px'} sx={{width: '100%', display: 'flex', justifyContent: 'center'}}>
          <img
            src={Logo}
            alt="Priwall logo"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
            style={{
              width: "260px", 
              height: "65px"
            }}
          />
        </Box>

        <Typography
          id="welcome-title"
          variant="inherit"
          sx={{
            fontWeight: 500,
            fontSize: {xs: 20, sm: 25, md: 30},
            color: '#FFFFFF',
            lineHeight: {xs: '25px', sm: '30px', md: '35px'},
            textAlign: 'center',
            width: '545px',
            marginBottom: {xs: '10px', sm: '12px', md: '15px'},
          }}
        >
         Are you sure?
        </Typography>

        <Typography
          id="welcome-description"
          variant="inherit"
          sx={{
            fontSize: {xs: 14, sm: 16},
            color: '#F3F3F3',
            fontWeight: 500,
            textAlign: 'center',
            width: '95%',
          }}
        >
            <Typography variant="inherit" sx={{mb: 4, lineHeight: {xs: '12px', sm: '20px', md: '25px'}}}>
            Before you skip, know that completing your profile helps us search more accurately across data broker sites. <br />
            </Typography>
            
            <Typography variant="inherit" sx={{mb: 4, lineHeight: {xs: '12px', sm: '20px', md: '25px'}}}>
            Adding names, cities, and states improves our scan. Including your LinkedIn URL lets us target sites like
            RocketReach and ZoomInfo. Your street address helps with brokers that require stricter identity checks. <br />
            </Typography>
            
            <Typography variant="inherit" sx={{mb: 6, lineHeight: {xs: '12px', sm: '20px', md: '25px'}}}>
            Skipping this step may limit how much of your data
            we can remove.
            </Typography>
        </Typography>
        
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 4}}>
        <Typography
          component="button"
          sx={{
            background: '#838db4',
            color: '#fff',
            borderRadius: {xs: 1},
            fontWeight: 500,
            fontSize: {xs: 10, sm:14, md: 16},
            width: {sx: '125px', sm: '150px', md: '200px'},
            border: 'none',
            height: {xs:'35px', sm: '40px', md: '50px'},
            marginBottom: {xs:'15px', sm: '20px', md: '20px'},
            lineHeight: { xs:'20px', sm: '25px', md: '30px'},
            display: 'block',
            '&:hover': {
              color: '#fff',
              boxShadow: 6,
              cursor: 'pointer',
            }
          }}
          onClick={handleSkip}
        >
          Skip
        </Typography>

        <Typography
          component="button"
          onClick={handleGoBack}
          sx={{
            background: '#9035DE',
            color: '#fff',
            borderRadius: {xs: 1},
            fontWeight: 500,
            fontSize: {xs: 10, sm:14, md: 16},
            width: {sx: '125px', sm: '150px', md: '200px'},
            border: 'none',
            height: {xs:'35px', sm: '40px', md: '50px'},
            marginBottom: {xs:'15px', sm: '20px', md: '20px'},
            lineHeight: { xs:'20px', sm: '25px', md: '30px'},
            display: 'block',
            '&:hover': {
              color: '#fff',
              cursor: 'pointer',
              boxShadow: 6
            }
          }}
        >
          Go Back
        </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(AppTourWelcomeModal);